import React, { useState } from 'react';
import { useSiteAuth } from '../context/SiteAuthContext';

const SitePasswordPrompt = () => {
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login, error } = useSiteAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    const result = await login(password);
    
    if (!result.success) {
      setPassword('');
    }
    
    setIsLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-lodge-brown-600 to-lodge-brown-800 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-lodge-brown-700 mb-2">
            Beaver Creek Guidebook
          </h1>
          <p className="text-gray-600">
            Please enter the password to access this site
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
              Password
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-lodge-brown-500 focus:border-transparent outline-none transition"
              placeholder="Enter password"
              required
              autoFocus
            />
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={isLoading || !password}
            className="w-full bg-lodge-brown-600 text-white py-3 px-4 rounded-lg font-medium hover:bg-lodge-brown-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? 'Verifying...' : 'Access Site'}
          </button>
        </form>

        <div className="mt-8 pt-6 border-t border-gray-200 text-center text-sm text-gray-500">
          This site is password protected. Please contact the administrator if you need access.
        </div>
      </div>
    </div>
  );
};

export default SitePasswordPrompt;